import { ca } from '@cian/analytics';
import { EPageBlock } from '../../../types/analytics';

type TAction = 'show_sopr' | 'Click';
type TBlock = 'beneficial' | 'promo_ending';

const trackCompilationEvent = (action: TAction, block: TBlock) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action,
    label: 'Block',
    page: {
      extra: {
        block,
      },
    },
  });
};

export const trackTopPromosShow = () => trackCompilationEvent('show_sopr', EPageBlock.Beneficial);
export const trackTopPromosClick = () => trackCompilationEvent('Click', EPageBlock.Beneficial);

export const trackLastChanceDiscountShow = () => trackCompilationEvent('show_sopr', EPageBlock.PromoEnding);
export const trackLastChanceDiscountClick = () => trackCompilationEvent('Click', EPageBlock.PromoEnding);
